import { Layout, LayoutProps } from 'antd';

export type LayoutAtomProps = LayoutProps;

const LayoutAtom = Layout;

export default LayoutAtom;